module.exports = __webpack_public_path__ + "img/46c3af23aa764d5d8e227ea1fb59a1c8.9aa12f26.png";